import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import { useRouter } from 'next/router';
import { addOrRemoveToCompare } from '../../../store/slices/compare';
import { PageLinks } from '../../../constants';

const RemoveFromCompare = ({ itineraryId, itinerary }) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { track } = useAnalytics();
  const isComparePage =
    router && router.pathname && router.pathname.indexOf(PageLinks.Compare.url) > -1;
  const { travelAgency } = useSelector((state) => state.user);
  const compareSettings =
    (travelAgency && travelAgency.settings && travelAgency.settings.compareSettings) || {};
  const displayLabel = (compareSettings.DisplayName || 'compare').toLowerCase();

  const handleRemoveFromCompare = () => {
    dispatch(
      addOrRemoveToCompare({
        itineraryId,
        itineraryToRemove: itinerary,
      }),
    );
    track('RemoveFromCompare.handleChange', {
      itineraryId,
    });
  };
  return !isComparePage ? (
    <button
      onClick={() => handleRemoveFromCompare()}
      type="button"
      className="text-theme focus:outline-none email-hidden-field"
    >
      <span>Remove from {displayLabel}</span>
    </button>
  ) : (
    <></>
  );
};

RemoveFromCompare.propTypes = {
  itineraryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  itinerary: PropTypes.shape(),
};

RemoveFromCompare.defaultProps = {
  itinerary: undefined,
};

export default RemoveFromCompare;
